export const roleDefinitions = {
  admin: [{ action: "*", modules: "*" }],
  super_admin: [{ action: "*", modules: "*" }],
  seo_executive: [
                  {action: [ "view"], modules: "dashboard" },
                  {action: ["edit", "view"], modules: "products" }, 
                  {action: ["edit", "view"], modules: "epuja" }, 
				  {action: ["edit", "view"], modules: "kundli_prediction" },
				  {action: ["edit", "view"], modules: "blogs" },
				  {action: ["edit", "view"], modules: "faq" },
				  {action: ["edit", "view"], modules: "page_content" },
				  ],
};
